module.exports = {
  computed: {
    /**
     * Access the global App object.
     */
    app () {
      return window.App;
    }
  },

  methods: {
    translate (keyword, attributes = null) {
      const paths = keyword.split('.');
      let current = window.App.translations;
      let i;

      for (i = 0; i < paths.length; ++i) {
        if (current[paths[i]] === undefined) {
          return keyword;
        } else {
          current = current[paths[i]];
        }
      }

      if ((typeof current === 'string') && (typeof attributes === 'object')) {
        _.forEach(attributes, (attribute, key) => {
          current = current.replace(`:${key}`, attribute);
        });
      }

      return current;
    }
  },
};
